// @TODO: This whole thing kind of sucks, and there's probably a way better
// method of doing it. Probably declaring an object with a bunch of keys and
// properties then assembling them as needed.

const paths = [
  '/',
  '/about-us',
  '/fast-facts',
  '/news',
  '/contact-us',
  '/privacy-policy',
  '/website-terms-of-use',
  '/what-is-my-claim-worth',
  '/what-we-do',
  '/bicycle-accidents',
  '/car-accidents',
  '/motor-bike-accidents',
  '/pedestrian-accidents',
  '/public-transport-accidents',
  '/tpd-and-superannuation-claims',
  '/wrongful-death-loss-of-dependency',
  '/truck-accidents',
  '/medical-negligence',
  '/workcover-and-workplace-accidents',
  '/electric-skateboard-accidents',
] as const;

type TConstantPaths = (typeof paths)[number];

type TLinkTree = {
  href: TConstantPaths;
  innerText: string;
  subNavigation?: TLinkTree[];
};

const headerNavigation: TLinkTree[] = [
  {
    href: '/',
    innerText: 'Home',
  },
  {
    href: '/what-we-do',
    innerText: 'Services',
    subNavigation: [
      {
        href: '/car-accidents',
        innerText: 'Motor Vehicle Accident Claims',
      },
      {
        href: '/tpd-and-superannuation-claims',
        innerText: 'TPD & Superannuation Claims',
      },
      {
        href: '/medical-negligence',
        innerText: 'Medical Negligence',
      },
      {
        href: '/workcover-and-workplace-accidents',
        innerText: 'Workcover & Workplace Accidents',
      },
      {
        href: '/bicycle-accidents',
        innerText: 'Bicycle Accident Claims',
      },
      {
        href: '/public-transport-accidents',
        innerText: 'Bus, Taxi & Rideshare Accident Claims',
      },
      {
        href: '/pedestrian-accidents',
        innerText: 'Pedestrian Accident Claims',
      },
      {
        href: '/wrongful-death-loss-of-dependency',
        innerText: 'Wrongful Death & Loss of Dependency Claims',
      },
      {
        href: '/motor-bike-accidents',
        innerText: 'Motorbike Accident Claims',
      },
      {
        href: '/truck-accidents',
        innerText: 'Truck Accident Claims',
      },
      {
        href: '/electric-skateboard-accidents',
        innerText: 'Electric Skateboard Accident Claims',
      },
    ],
  },
  {
    href: '/about-us',
    innerText: 'About us',
  },
  {
    href: '/news',
    innerText: 'News',
  },
  {
    href: '/contact-us',
    innerText: 'Contact us',
  },
];

const footerNavigation: TLinkTree[] = [
  ...headerNavigation.filter(
    (v) =>
      (
        [
          '/',
          '/about-us',
          '/what-we-do',
          '/fast-facts',
          '/news',
          '/contact-us',
        ] as TConstantPaths[]
      ).indexOf(v.href) >= 0,
  ),
  {
    href: '/what-is-my-claim-worth',
    innerText: 'What is my claim worth?',
  },
];

const useNavigationItems = (location: 'header' | 'footer') =>
  location === 'header' ? headerNavigation : footerNavigation;

export { useNavigationItems, paths };
export type { TLinkTree, TConstantPaths };
